/* Toast queue. Any module can call toast(); the <Toaster> component renders the queue. */
import type { IconName } from '../ui/icons';
import { Emitter } from './events';

export type Tone = 'good' | 'bad' | 'info' | 'warn';

export interface ToastItem {
  id: number;
  text: string;
  tone?: Tone;
  icon?: IconName;
  ms: number;
}

let items: ToastItem[] = [];
let nextId = 1;
const events = new Emitter<{ change: ToastItem[] }>();

export function toast(text: string, o: { tone?: Tone; icon?: IconName; ms?: number } = {}): void {
  const item: ToastItem = { id: nextId++, text, tone: o.tone, icon: o.icon, ms: o.ms ?? 2600 };
  items = [...items, item];
  events.emit('change', items);
}

export function dismissToast(id: number): void {
  items = items.filter((t) => t.id !== id);
  events.emit('change', items);
}

export const getToasts = (): ToastItem[] => items;
export const subscribeToasts = (fn: () => void): (() => void) => events.on('change', fn);
